import React from 'react';

const Percent = ({ value }) => (
  <>
    {+(`${Math.round(`${value || 0}e+4`)}e-2`)}%
  </>
);

export default Percent;
